import React from 'react';
import { LuPhone, LuMapPin } from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="kontak" className="bg-navy pt-20 pb-8 border-t-[6px] border-orange">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-24 mb-16">
          
          {/* Brand Info */}
          <div>
            <img 
              src="/images/logo-garuda.png" 
              alt="Garuda Ekspress Logistik" 
              className="h-[38px] md:h-[51px] w-auto object-contain mb-8"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="text-gray-300 text-lg max-w-md leading-relaxed">
              Mitra logistik terpercaya Anda. Kami hadir memberikan solusi pengiriman terbaik untuk menghubungkan bisnis dan individu di seluruh Nusantara.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-8">Hubungi Kami</h4>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-orange/20 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={LuPhone} className="w-6 h-6 text-orange" />
                </div>
                <div className="pt-1">
                  <p className="text-gray-400 text-sm mb-1">WhatsApp & Telepon</p>
                  <a href="https://wa.me/6288212309927" target="_blank" rel="noreferrer" className="font-heading text-white text-xl font-semibold hover:text-orange transition-colors">
                    0882-1230-9927
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-orange/20 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={LuMapPin} className="w-6 h-6 text-orange" />
                </div>
                <div className="pt-1">
                  <p className="text-gray-400 text-sm mb-1">Kantor Pusat</p>
                  <p className="text-white leading-relaxed font-medium">
                    Jalan Bojong Indah Raya No. 27,<br />
                    Kel. Rawa Buaya, Kec. Cengkareng,<br />
                    Jakarta Barat
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © Garuda Ekspress Logistik. All Rights Reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <Link to="/terms" onClick={() => window.scrollTo(0,0)} className="font-heading hover:text-white transition-colors">Syarat & Ketentuan</Link>
            <Link to="/privacy" onClick={() => window.scrollTo(0,0)} className="font-heading hover:text-white transition-colors">Kebijakan Privasi</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}